import React from "react";
import PageWrapper from "../components/PageWrapper";
import MapItem from "../components/MapItem";
import Footer from "../components/Footer";
import { useParams } from "react-router-dom";

const Map = (props) => {
  return (
      <PageWrapper>
        <div className="Map homepage">
          <MapItem />
          <Footer />
        </div>
      </PageWrapper>
  );
};

export default Map;
